<div class="container">
  <app-admin-search (statusFilterChanged)="updateByStatus($event)"></app-admin-search>
  <hr class="my-4">
  <app-admin-practitioner-item
    *ngFor="let practitioner of practitioners"
    [practitioner]="practitioner"
    (practitionerUpdated)="refreshList()">
  </app-admin-practitioner-item>
  <hr class="my-4">
</div>
